import BasePage from '../../../../../../components/table_page';
import Form from '../form';
import request from '../../../../../../utils/request';

export default {
  name: 'promotion_policy',
  extends: BasePage,
  data() {
    return {
      budgetState: null,
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('tpm_promotion_policy_list');
    request
      .get('/mdm/mdmParameterController/getParameterValue', {
        parameterCode: 'budget_use_date_rule',
      })
      .then((res) => {
        this.budgetState = res.result;
      });
  },
  methods: {
    modalClick({ val, row }) {
      const { code } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
          budgetState: this.budgetState,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
    },
  },
};
